import {
  Navbar,
  NavbarBrand,
  NavbarContent,
  NavbarItem,
  NavbarMenuToggle,
} from '@nextui-org/react';
import useNavConfig from '@hooks/useNavConfig';
import { NavItem } from '@commons/layouts/dashboard/item';
import Logo from '@commons/logo';
import { enteiPallete } from '@PorkyCol/theme';
import { useEffect } from 'react';
import { useAuthContext } from '@hooks/useAuthContext';
import { useUserNotifications } from '@/context/user-notifications/hooks';
import { NotificationNav } from '@modules/notification/page/notification-nav';
import { Settings } from './settings';
import { User } from './user';

export const Header = ({ handleOpen }: any) => {
  const { newNav } = useNavConfig();
  const { fetchNotifications, startRealtimeUpdates, stopRealtimeUpdates } = useUserNotifications();
  const { user, isAuthenticated } = useAuthContext();
  useEffect(() => {
    if (user?.id) {
      fetchNotifications(`${user.id}`);
      startRealtimeUpdates(`${user.id}`);
    }
    return () => {
      if (user?.id) {
        stopRealtimeUpdates();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, user?.id, user?.branchSelected?.id]);
  return (
    <Navbar
      classNames={{
        base: 'pt-2 lg:pt-4 bg-[#ffffff] lg:backdrop-filter-none',
        wrapper: 'px-4 sm:px-6 w-full max-w-full',
        item: 'data-[active=true]:text-primary',
      }}
      isBordered
      isMenuOpen={false}
      height="60px"
    >
      <NavbarBrand className="grow-[0.15] lg:grow-[0.2] gap-2">
        <NavbarMenuToggle className="mr-2 h-6 sm:hidden" onClick={handleOpen} />
        <Logo fill={(enteiPallete.primary as any)?.DEFAULT as string} height={80} width={80} />
      </NavbarBrand>
      <NavbarContent
        className="ml-4 hidden h-12 w-full max-w-fit gap-4 rounded-full bg-content2 px-4 dark:bg-content1 md:flex overflow-x-auto"
        justify="start"
      >
        {Array.isArray(newNav) &&
          newNav[0]?.items?.map((item: Record<string, any>, index: number) => (
            <NavItem key={`${index}-menu-new-header`} item={item} />
          ))}
      </NavbarContent>
      <NavbarContent
        className="ml-auto flex h-12 max-w-fit items-center gap-0 rounded-full p-0 lg:bg-content2 lg:px-1 lg:dark:bg-content1"
        justify="end"
      >
        {/* Settings */}
        <NavbarItem className="lg:flex">
          <Settings />
        </NavbarItem>
        {/* Notifications */}
        <NavbarItem className="flex">
          <NotificationNav />
        </NavbarItem>
        {/* User Menu */}
        <User isNav />
      </NavbarContent>
    </Navbar>
  );
};
